<!-- 体重のチャート -->
<template>
  <div class="small">
    <line-chart :chartdata="chartdata" :options="options" :width="1000" />
  </div>
</template>

<script>
/* storeからweightを読み込む
   linechart用のデータセットにセットする
   このコンポーネントを、カラダ日記.vueで読み込む
*/
import VueTypes from "vue-types";
import LineChart from "./LineChart.js";

export default {
  components: {
    LineChart
  },
  props: {
    label: VueTypes.arrayOf(VueTypes.string).isRequired,
    weight: VueTypes.arrayOf(VueTypes.number).def(0)
  },
  data() {
    return {
      options: {
        responsive: true,
        scales: {
          yAxes: [{
          ticks: {
            suggestedMax: 89,
            suggestedMin: 20,
            stepSize: 10,
            callback: function(value, index, values){
              return  value +  'kg'
            }
          }
        }]
      }
      },
    };
  },
  computed: {
    chartdata() {
      return {
        labels: this.label,
          datasets: [
            {
              label: this.$t('notebook.legendBodyWeight'),
              borderColor: "#95BE91",
              backgroundColor: "rgba(0, 0, 0, 0)",
              lineTension: 0,
              data: this.weight
            }
          ]
      }
    }
  }
};
</script>

<style scoped>
.small {
  margin: auto;
}
</style>
